/**
 * Centralized Logging Utility for Frontend
 * 
 * Restricts console logging based on environment.
 * In production, only errors and warnings are logged.
 * In development, all log levels are available.
 */

const isDevelopment = !import.meta.env.PROD;

export const logger = {
  /**
   * Log debug information (development only)
   */
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },

  /**
   * Log general information (development only)
   */
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },

  /**
   * Log informational messages (development only)
   */
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },

  /**
   * Log warnings (always shown)
   */
  warn: (...args: any[]) => {
    console.warn('[WARN]', ...args);
  },

  /**
   * Log errors (always shown)
   */
  error: (...args: any[]) => {
    console.error('[ERROR]', ...args);
  },

  /**
   * Log API requests (development only)
   */
  api: (method: string, url: string, data?: any) => {
    if (isDevelopment) {
      console.log(`[API] ${method} ${url}`, data ? data : '');
    }
  },

  /**
   * Log API responses (development only)
   */
  apiResponse: (method: string, url: string, status: number, data?: any) => {
    if (isDevelopment) {
      console.log(`[API RESPONSE] ${method} ${url} - Status: ${status}`, data ? data : '');
    }
  },

  /**
   * Log user actions (development only, useful for debugging UX issues)
   */
  userAction: (action: string, details?: any) => {
    if (isDevelopment) {
      console.log(`[USER ACTION] ${action}`, details ? details : '');
    }
  }
};

export default logger;
